// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"1b2e80c4","453":"b705f362","535":"9276ef6c"}[chunkId] + ".chunk.js";
};